var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFyrreMagazineLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 19,
    viewBox: "0 0 210 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.648 18.116V11.54H9.96V8.39599H3.648V4.05199H11.136V0.883986H0V18.116H3.648Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7526 11.636L27.8966 0.883986H24.2246L20.0486 8.29999L15.9446 0.883986H12.0086L18.1046 11.636V18.116H21.7526V11.636Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4605 18.116V12.02H35.7405L39.6285 18.116H43.9725L39.5325 11.468C41.9805 10.652 43.4205 8.80399 43.4205 6.47599C43.4205 2.89999 40.9005 0.883986 36.5565 0.883986H29.8125V18.116H33.4605ZM33.4605 3.90799H36.3885C38.5965 3.90799 39.7725 4.77199 39.7725 6.47599C39.7725 8.15599 38.5965 9.01999 36.3885 9.01999H33.4605V3.90799Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8902 18.116V12.02H52.1702L56.0582 18.116H60.4022L55.9622 11.468C58.4102 10.652 59.8502 8.80399 59.8502 6.47599C59.8502 2.89999 57.3302 0.883986 52.9862 0.883986H46.2422V18.116H49.8902ZM49.8902 3.90799H52.8182C55.0262 3.90799 56.2022 4.77199 56.2022 6.47599C56.2022 8.15599 55.0262 9.01999 52.8182 9.01999H49.8902V3.90799Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2639 14.948H66.3199V10.82H73.3759V7.67599H66.3199V4.05199H74.0959V0.883986H62.6719V18.116H74.2639V14.948Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9256 18.116H92.9736L97.5336 6.57199V18.116H100.846V0.883986H96.4776L91.4616 13.652L86.4696 0.883986H82.1016V18.116H85.4136V6.66799L89.9256 18.116Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.887 18.116H119.799L113.367 0.883986H109.383L102.903 18.116H106.575L107.895 14.42H114.591L115.887 18.116ZM111.279 4.86799L113.583 11.516H108.927L111.279 4.86799Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.763 18.476C134.259 18.476 137.667 14.444 137.451 8.82799H128.571V11.732H133.563C133.083 13.868 131.475 15.38 128.931 15.38C125.475 15.38 123.627 12.836 123.627 9.52399C123.627 5.82799 125.739 3.78799 128.523 3.78799C130.827 3.78799 132.411 5.10799 132.939 6.85999H137.235C136.107 3.11599 132.987 0.523987 128.619 0.523987C123.579 0.523987 119.883 4.33999 119.883 9.42799C119.883 14.756 123.771 18.476 128.763 18.476Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.598 18.116H154.51L148.078 0.883986H144.094L137.614 18.116H141.286L142.606 14.42H149.302L150.598 18.116ZM145.99 4.86799L148.294 11.516H143.638L145.99 4.86799Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.401 18.116V14.972H160.257L169.113 3.81199V0.883986H155.841V4.02799H164.625L155.817 15.236V18.116H169.401Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175.703 18.116V0.883986H172.055V18.116H175.703Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M190.459 18.116H194.035V0.883986H190.675V12.308L183.163 0.883986H179.227V18.116H182.563V6.09199L190.459 18.116Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.17 14.948H201.226V10.82H208.282V7.67599H201.226V4.05199H209.002V0.883986H197.578V18.116H209.17V14.948Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyrreMagazineLogoBlack);
export default __webpack_public_path__ + "static/media/FyrreMagazineLogo-Black.0cff740e5d56d88def8011318aeaa160.svg";
export { ForwardRef as ReactComponent };